<template>
  <div>
    <page-head :title="title" :show-back="true"></page-head>
    <div class="content">
      <div class="card">
        <div class="card-body">
          <div class="audit-success" v-if="info.isCheck === 1">
            <div class="audit-body">
              <div class="icon-group">
                <Icon type="ios-checkmark-circle" />审核通过!
              </div>
              <div class="desc"></div>
            </div>
          </div>
          <div class="audit-fail" v-if="info.isCheck === 2">
            <div class="audit-body">
              <div class="icon-group"><Icon type="ios-alert" />审核未通过</div>
              <div class="desc">{{ info.remark }}</div>
              <div class="btn">
                <Button size="small" type="default" @click="handleBtn('not')"
                  >编辑</Button
                >
              </div>
            </div>
          </div>
          <div class="audit-waiting" v-if="info.isCheck === 0">
            <div class="audit-body">
              <div class="icon-group"><Icon type="ios-alert" />待审核</div>
            </div>
          </div>
          <div class="audit-past" v-if="info.isCheck === 3">
            <div class="audit-body">
              <div class="icon-group"><Icon type="ios-albums" />已归档</div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          基本信息
          <div class="btn-group text-right">
            <Button
              v-if="info.isCheck === 1 || info.isCheck === 2"
              class="bkcc-btn del-btn"
              @click="handleBtn('cancel')"
              >取消审核</Button
            >
            <Button
              v-if="info.isCheck === 0"
              class="bkcc-btn del-btn"
              @click="handleBtn('not')"
              >审核不通过</Button
            >
            <Button
              v-if="info.isCheck === 0"
              class="bkcc-btn del-btn"
              @click="handleBtn('pass')"
              >审核通过</Button
            >
            <Button class="bkcc-btn del-btn" @click="handleBtn('edit')"
              >编辑</Button
            >
          </div>
        </div>
        <div class="card-body">
          <row>
            <i-col span="4">
              <img
                v-if="info.headPicUrl"
                class="headPicUrl"
                :src="info.headPicUrl"
              />
            </i-col>
            <i-col span="16">
              <row class="form-item-group">
                <Form>
                  <i-col span="12">
                    <FormItem label="姓名">
                      <div class="detail">
                        {{ info.userName || "暂无数据" }}
                      </div>
                    </FormItem>
                  </i-col>
                  <i-col span="12">
                    <FormItem label="联系电话">
                      <div class="detail">{{ info.phoneNO || "暂无数据" }}</div>
                    </FormItem>
                  </i-col>
                  <i-col span="12">
                    <FormItem label="派驻类别">
                      <div class="detail">
                        <span v-if="info.partyTypeList">
                          {{ partyTypeName(info.partyTypeList) }}
                        </span>
                        <span v-if="!info.partyTypeList">
                          {{ partyTypeName(info.partyType) }}
                        </span>
                      </div>
                    </FormItem>
                  </i-col>
                  <i-col span="12">
                    <FormItem label="服务企业">
                      <div class="detail">
                        {{ info.companyNames || "暂无数据" }}
                      </div>
                    </FormItem>
                  </i-col>
                </Form>
              </row>
            </i-col>
          </row>
        </div>
        <div class="card-footer text-center">
          <span @click="goToMoreDetail">查看更多</span>
        </div>
      </div>
      <div class="table-tabs">
        <tabs v-model="cate" @on-click="clickChange" :animated="false">
          <tab-pane label="工作记实" name="work" :disabled="isTableLoading">
            <div class="table-data">
              <i-table
                :columns="workTableHeader"
                :border="true"
                :loading="isTableLoading"
                :data="tableData"
                stripe
              >
                <template slot-scope="{ row }" slot="action">
                  <span @click="goWorkDetail(row)">[详情]</span>
                </template>
              </i-table>
              <div class="page">
                <page
                  :total="total"
                  :current="pageNum"
                  @on-change="pageChange"
                  show-total
                />
              </div>
            </div>
          </tab-pane>
          <tab-pane label="每月自评" name="evaluate" :disabled="isTableLoading">
            <div class="table-data">
              <i-table
                :columns="monthTableHeader"
                :border="true"
                :loading="isTableLoading"
                :data="tableData"
                stripe
              >
                <template slot-scope="{ row }" slot="partyTypeList">
                  <span v-if="row.partyTypeList">
                    {{ partyTypeName(row.partyTypeList) }}
                  </span>
                  <span v-if="!row.partyTypeList">
                    {{ partyTypeName(row.partyType) }}
                  </span>
                </template>
                <template slot-scope="{ row }" slot="grade">
                  <span v-if="row.grade === 1" class="fine-color">优秀</span>
                  <span v-if="row.grade === 2" class="qualify-color">称职</span>
                  <span v-if="row.grade === 3" class="commonly-color"
                    >不称职</span
                  >
                </template>
                <template slot-scope="{ row }" slot="recordDate">
                  {{ row.recordDate.substring(0, 7) }}
                </template>
              </i-table>
              <div class="page">
                <page
                  :total="total"
                  :current="pageNum"
                  @on-change="pageChange"
                  show-total
                />
              </div>
            </div>
          </tab-pane>
        </tabs>
      </div>
    </div>
    <Modal v-model="modalIsOpen" :title="modalTitle" :width="550">
      <div>
        {{ modalTitle }}原因（{{ currentIsCheck === 2 ? "必填" : "选填" }}）
      </div>
      <br />
      <Input
        type="textarea"
        v-model="checkMsg"
        :rows="5"
        placeholder="请填写原因..."
      />
      <div slot="footer">
        <Button style="margin-right:10px" @click="modalIsOpen = false"
          >取消</Button
        >
        <Button type="primary" @click="auditHandler" :loading="isBtbLoading"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
const {
  postChiefWaiter,
  postChiefWaiterDocumentaryWork,
  postChiefWaiterEvaluateList,
  getChiefWaiterDetail
} = api;
import { getPartyTypeDic } from "./dic";
export default {
  name: "waiterManagerDetail",
  components: {
    pageHead
  },
  data() {
    return {
      title: "用户详情",
      pageNum: 1,
      pageSize: 10,
      total: 0,
      checkMsg: "",
      modalTitle: "",
      modalIsOpen: false,
      isBtbLoading: false,
      currentAuditId: "",
      currentIsCheck: 1,
      cate: "work",
      tableIndex: 0,
      info: {},
      partyTypeList: [],
      tableData: [],
      isTableLoading: false,
      workTableHeader: [
        {
          title: "序号",
          type: "index",
          width: 80
        },
        // {
        //   title: "姓名",
        //   key: "userName"
        // },
        // {
        //   title: "联系电话",
        //   key: "phoneNO"
        // },
        // {
        //   title: "派驻类别",
        //   key: "partyTypeName"
        // },
        {
          title: "服务企业",
          key: "companyName"
        },
        {
          title: "收集问题",
          key: "collectNum"
        },
        {
          title: "解决问题",
          key: "solveNum"
        },
        {
          title: "服务日期",
          key: "recordDate"
        },
        {
          title: "操作",
          slot: "action"
        }
      ],
      monthTableHeader: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center"
        },
        {
          title: "姓名",
          key: "userName"
        },
        {
          title: "联系电话",
          key: "phoneNO"
        },
        {
          title: "派驻类别",
          slot: "partyTypeList"
        },
        {
          title: "服务企业",
          key: "companyName"
        },
        {
          title: "评价",
          slot: "grade"
        },
        {
          title: "评价月",
          slot: "recordDate"
        }
      ]
    };
  },
  computed: {
    partyTypeName() {
      return function(type) {
        if (!type) return;
        const levelArr = type.split(",");
        let name = "";
        this.partyTypeList.filter(item => {
          if (item.value === levelArr[0]) {
            name = item.label;
            if (levelArr[1] && item.children) {
              item.children.filter(inner => {
                if (inner.value === levelArr[1]) {
                  name = name + "/" + inner.label;
                }
              });
            }
          }
          return;
        });
        console.log("看看处理后的数据：", name);
        return name;
      };
    }
  },
  methods: {
    handleBtn(type) {
      const handler = this[type + "Handler"];
      handler && handler();
    },
    // 编辑
    editHandler() {
      console.log("我是编辑");
      this.$router.push({
        name: "addChiefWaiter",
        query: { id: this.info.id }
      });
    },
    // 取消审核
    cancelHandler() {
      console.log("我是取消审核");
      this.currentAuditId = this.info.id;
      this.currentIsCheck = 0;
      this.$Modal.confirm({
        title: "是否取消审核",
        onOk: () => {
          this.auditHandler();
        }
      });
    },
    // 审核不通过
    notHandler() {
      console.log("我是审核不通过");
      this.modalTitle = "审核不通过";
      this.currentAuditId = this.info.id;
      this.currentIsCheck = 2;
      this.openModal();
    },
    // 审核通过
    passHandler() {
      console.log("我是审核通过");
      this.modalTitle = "审核通过";
      this.currentAuditId = this.info.id;
      this.currentIsCheck = 1;
      this.openModal();
    },
    pageChange(val) {
      this.pageNum = val;
      if (this.tableIndex === "work") {
        this.getList(postChiefWaiterDocumentaryWork);
      }
      if (this.tableIndex === "evaluate") {
        this.getList(postChiefWaiterEvaluateList);
      }
    },
    // 去详情页面
    goToMoreDetail() {
      console.log("去详情页面");
      this.$router.push({
        name: "waiterManagerMoreDetail",
        query: { id: this.info.id }
      });
    },
    // tab 切换
    clickChange(val) {
      console.log(val);
      this.tableIndex = val;
      this.pageNum = 1;
      if (val === "work") {
        this.getList(postChiefWaiterDocumentaryWork);
      }
      if (val === "evaluate") {
        this.getList(postChiefWaiterEvaluateList);
      }
    },
    // 去工作记实详情
    goWorkDetail(row) {
      const { id } = row;
      // console.log("工作记实详情id: ", row);
      this.$router.push({
        name: "documentaryWork",
        query: { id }
      });
    },
    // 获取基本信息
    async getBaseInfo() {
      const id = this.$route.query.id;
      // console.log("看看当前id: ", id);
      const res = await this.$get(getChiefWaiterDetail(id));
      // console.log(this.query);
      // console.log("看看当前数据", res.rows);
      if (res.isSucceed) {
        this.info = res.rows[0];
        this.getList(postChiefWaiterDocumentaryWork);
      }
    },
    // 获取工作记实 每月自评
    async getList(url) {
      this.isTableLoading = true;
      const unionId = this.info.unionId;
      const res = await this.$post(url, {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        unionId
      });
      if (res.isSucceed) {
        this.isTableLoading = false;
      }
      console.log("看看工作记实数据", res);
      const data = res.rows.map(item => ({
        ...item,
        userName: this.info.userName,
        phoneNO: this.info.phoneNO,
        partyTypeList: this.info.partyTypeList
      }));
      this.tableData = data;
      this.total = res.total || 0;
    },
    // 打开模态框
    openModal() {
      if (!this.modalIsOpen) {
        this.modalIsOpen = true;
        this.checkMsg = "";
      }
    },
    async auditHandler() {
      if (this.currentIsCheck === 2) {
        if (!this.checkMsg) {
          return this.$Message.info("请填写审核说明");
        }
      }
      const id = this.currentAuditId || "";
      const isCheck = this.currentIsCheck;
      const remark = this.checkMsg || "";
      // console.log("看看这里是什么数据", remark);
      this.isBtbLoading = true;
      try {
        const res = await this.$post(postChiefWaiter, {
          remark,
          id,
          isCheck
        });
        if (res.isSucceed) {
          this.modalIsOpen = false;
          this.checkMsg = "";
          this.$Message.info("操作成功");
          this.getBaseInfo();
        }
      } finally {
        this.isBtbLoading = false;
        this.checkedId = "";
      }
    },
    // 获取驻派类别
    async getPartyTypeList() {
      const res = await this.$get(getPartyTypeDic);
      this.partyTypeList = res.rows.length ? this.formateData(res.rows) : [];
      // console.log("查看驻派类别数据：", this.partyTypeList);
    },
    // 格式化驻派类别数据
    formateData(data) {
      let returnData = data.map(item => {
        return {
          value: item.dicType,
          label: item.dicName,
          children: item.children.length ? this.formateData(item.children) : []
        };
      });
      return returnData;
    }
  },
  created() {
    this.getPartyTypeList();
    this.getBaseInfo();
  }
};
</script>

<style scoped lang="less">
.fine-color {
  color: #47ba54;
}
.qualify-color {
  color: #00a0ea;
}
.commonly-color {
  color: #ff7b44;
}
.not-qualify-color {
  color: #ee5e51;
}
.content {
  margin: 20px;
}
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
}
.d-flex {
  display: flex;
}
.justify-content-between {
  justify-content: space-between;
}
.align-items-center {
  align-items: center;
}
/deep/ .ivu-form-item-label {
  color: #9a9a9a;
}
/deep/ .ivu-icon {
  // width: 34px;
  // height: 34px;
  font-size: 30px;
  margin-right: 4px;
}
.table-tabs {
  max-width: 100%;
  padding: 0;
  margin-top: 30px;
  /deep/ .ivu-tabs-tab:hover {
    color: #ff7b44;
  }
  /deep/ .ivu-tabs-bar {
    position: relative;
    margin-bottom: 2px;
    border-bottom: 0;
  }
  /deep/ .ivu-tabs-tab-active {
    color: white;
    background: #fe7d43;
    border-radius: 5px 5px 0 0;
    &:hover {
      color: white;
    }
  }
  /deep/ .ivu-tabs-ink-bar {
    height: 0px;
  }
  /deep/ .ivu-tabs-nav {
    padding-left: 10px;
    color: black;
  }
  /deep/ .ivu-tabs-tab {
    font-weight: bold;
  }
}

.audit-success,
.audit-fail,
.audit-waiting,
.audit-past {
  font-size: 18px;
  font-weight: bold;
  .desc,
  .btn {
    margin-left: 34px;
  }
  .desc {
    font-size: 16px;
    color: #999999;
    text-shadow: none;
  }
}
.audit-success {
  color: #5bc373;
  text-shadow: 0px 2px 2px rgba(72, 157, 92, 0.21);
}
.audit-fail {
  color: #e5824f;
  text-shadow: 0px 2px 2px rgba(126, 33, 20, 0.21);
}
.audit-waiting {
  color: #e5824f;
  text-shadow: 0px 2px 2px rgba(136, 57, 23, 0.21);
}
.audit-past {
  color: #8cc64e;
  text-shadow: 0px 2px 2px #8cc64e36;
}
.card {
  background-color: white;
  border-radius: 5px;
  margin-bottom: 20px;
  .card-header {
    padding: 20px;
    border-bottom: 1px solid #dedede;
  }
  .card-body {
    padding: 20px;
    .card-title {
      color: #ff7c44;
    }
    .icon-group {
      display: flex;
      align-items: center;
    }
  }
  .card-footer {
    padding: 20px;
  }
}
.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}
.detail {
  color: #666;
}
.headPicUrl {
  // display: block;
  height: 80px;
  width: 80px;
  margin-bottom: 20px;
  margin-right: 10px;
}
.success {
  color: #ff7b44;
}
.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  min-height: calc(100vh - 530px);
  .page {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  .verifyRecord {
    padding-left: 10px;
    margin-bottom: 20px;
    border-left: 3px solid #ff794e;
    height: 16px;
    line-height: 16px;
  }
}
</style>
